export const headTypeMap = {
  Driver: 1,
  Fairway: 2,
  Hybrid: 3,
  Iron: 4,
  Wedge: 5,
  Putter: 6,
  Utility: 7,
  // BSG does not have a headTypeId, so we set 0
  ['Ball,Shoe,Glove']: 0,
} as const;
